import { computed } from 'vue';

import { useQueryV2 } from '@libs/use';

import * as API from '../../requests';
import { PORTFOLIO_QUERY_KEYS } from '../../constants';

export default function useGetEmbeddedPutOptionSymbolsQuery() {
  const {
    result,
    execute: getEmbeddedPutOptionSymbols,
    isPending: isLoadingEmbeddedPutOptionSymbols,
    isSuccess: isSuccessLoadingEmbeddedPutOptionSymbols,
    isError: isErrorLoadingEmbeddedPutOptionSymbols,
  } = useQueryV2(API.getEmbeddedPutOptionSymbols, {
    key: PORTFOLIO_QUERY_KEYS.embeddedPutOptionSymbols,
  });

  const embeddedPutOptionSymbols = computed(() => result.value?.data || []);

  return {
    embeddedPutOptionSymbols,
    getEmbeddedPutOptionSymbols,
    isLoadingEmbeddedPutOptionSymbols,
    isSuccessLoadingEmbeddedPutOptionSymbols,
    isErrorLoadingEmbeddedPutOptionSymbols,
  };
}
